"use client";

import React, { useEffect } from "react";
import { useJoinCommunity } from "../../lib/util";
import DownloadApp from "./DownloadApp";
import ImageComponent from "./ImageComponent";

const ThankYou = ({ host, loggedInUser, data, isMember }) => {
  const { isLoading: isLoadingJoinCommunity, mutate: mutateJoinCommunity } =
    useJoinCommunity({
      onError: (response) => {
        setError(response.message);
      },
      onSuccess: async (response) => {},
    });

  useEffect(() => {
    if (typeof window === "undefined") return;

    if (window.scrollY > 0) {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }, []);

  const renderHostAvatar = () => {
    if (host && host.image) {
      return (
        <ImageComponent
          src={host.image}
          alt="Host Avatar"
          className="host-avatar"
        />
      );
    }
    if (host && host.name) {
      const initials = host.name
        .split(" ")
        .map((name) => name[0])
        .join("");
      return (
        <div className="host-avatar host-avatar-placeholder">{initials}</div>
      );
    }
    return null;
  };

  const handleJoinCommunity = () => {
    if (loggedInUser && loggedInUser.user) {
      mutateJoinCommunity({
        orgId: host.profileId,
        userId: loggedInUser.user.userId,
      });
    }
  };

  return (
    <>
      <div className="thank-you-message">
        <h1>Thank You for Your Purchase!</h1>
        <p>
          Your order was successful. You will receive a confirmation email or
          sms shortly. If you have any questions, please contact our support
          team.
        </p>
        {host && host.profileType === "ORGANISATION" && (
          <div className="thank-you-join">
            <div className="thank-you-join-div">
              {loggedInUser && loggedInUser.user ? (
                <>
                  <div className="host-info">
                    <h2>Join {host.name} Community on CirclePlug</h2>
                    {renderHostAvatar()}
                    <p>{host.name}</p>
                    {!isMember ? (
                      <button
                        className="join-community-button"
                        onClick={handleJoinCommunity}
                        disabled={isLoadingJoinCommunity}
                      >
                        {isLoadingJoinCommunity
                          ? "Joining Community..."
                          : "Join Community"}
                      </button>
                    ) : (
                      <div className="join-success-message">
                        <p>
                          You are already a member of {host.name} community!
                        </p>
                      </div>
                    )}
                  </div>
                </>
              ) : (
                <>
                  <p>
                    Your Order has been set to your email{" "}
                    <b>{data.user.email}</b>. Thanks for purchasing
                  </p>
                </>
              )}
              {/* Always show download button */}
              <div className="download-buttons">
                <div className="getit">
                  <div className="getiton">
                    Download the Circleplug App to stay connected with{" "}
                    {host.name}
                  </div>
                  <DownloadApp />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      {/* <div className="decision-btns">
        <button>Continue Shopping</button>
        <button className="btn-shop">Go to Marketplace</button>
      </div> */}
    </>
  );
};

export default ThankYou;
